module.exports = __webpack_public_path__ + "assets/videos/solar-eclipse-header-desktop.mp4?v=760fe460";